import actions from "./actions.js";

const initState = {
  lang: "tw",
  photo: "",
  apikey: "0d0f233cc6191fd35a3d7fb294f17a0a",
  buildingId: 67,
  buildingCode: "lujiang_parking",
  floorHeight: 40,
  maxHeight: 10000,
  floorTable: [],
  floorList: [],
  KIOSK_POI_ID: 9859,
  SELF_KIOSK_ID: undefined,
  startPoint: {
    PosX: 129.06409616919393,
    PosY: 117.14565043894652,
    map_id: 131,
  },
  searchType: "pnr" /* pnr or lpr */,
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case actions.SET_LANG:
      return {
        ...state,
        lang: action.lang,
      };
    case actions.SET_APIKEY:
      return {
        ...state,
        apikey: action.apikey,
      };
    case actions.SET_BUILDING_ID:
      return {
        ...state,
        buildingId: action.buildingId,
      };
    case actions.SET_BUILDING_CODE:
      return {
        ...state,
        buildingCode: action.buildingCode,
      };
    case actions.SET_FLOORTABLE:
      return {
        ...state,
        floorTable: action.floorTable,
      };
    case actions.SET_FLOORLIST:
      return {
        ...state,
        floorList: action.floorList,
      };
    case actions.SET_SEARCHTYPE:
      return {
        ...state,
        searchType: action.searchType,
      };
    case actions.SET_KIOSK_POI_ID:
      /* if SELF_KIOSK_ID is not undefined (set from url parameter) use SELF_KIOSK_ID */
      return {
        ...state,
        KIOSK_POI_ID: action.KIOSK_POI_ID,
      };
    case actions.SET_SELF_KIOSK_ID:
      return {
        ...state,
        KIOSK_POI_ID: action.SELF_KIOSK_ID,
        SELF_KIOSK_ID: action.SELF_KIOSK_ID,
      };
    case actions.SET_START_POINT:
      return {
        ...state,
        startPoint: action.startPoint,
      };
    case actions.SET_REGION_LOGO:
      return {
        ...state,
        photo: action.photo,
      }
    default:
      return state;
  }
};

export default reducer;
